// Backend API configuration
// Note: Endpoints already include /api prefix, so base URL should NOT include /api
export const API_BASE_URL = import.meta.env.VITE_API_BASE || 
  (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");
